/* LIVA — The First Hug. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var LV = window.LV || { routes: {}, strings: {}, fx: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var root = (LV.routes && LV.routes.root) || '/';
  if (root.slice(-1) !== '/') root += '/';

  /* ---------- Money ---------- */
  function money(cents) {
    var fmt = LV.moneyFormat || '${{amount}}';
    var n = (Number(cents) || 0) / 100;
    var withDelim = function (v, d, sep, dec) {
      var p = v.toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep);
      return p.join(dec);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withDelim(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return withDelim(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return withDelim(n, 0, '.', ',');
      return withDelim(n, 2, ',', '.');
    });
  }
  LV.money = money;

  /* ---------- Reveal + play-on-view (touch devices get icon animations once) ---------- */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      if (e.target.hasAttribute('data-lv-play')) {
        e.target.classList.add('is-play');
        setTimeout(function () { e.target.classList.remove('is-play'); }, 1600);
      }
      io.unobserve(e.target);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' }) : null;
  function observe(scope) {
    $$('[data-reveal], [data-lv-play], .lv-hero, .lv-footer, .lv-h1, .lv-h2', scope).forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }
  observe(document);

  /* Videos play only while visible */
  var vio = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { if (v.preload === 'none') v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.25 }) : null;
  function videos(scope) { $$('video.lv-video, .lv-video video', scope).forEach(function (v) { v.muted = true; if (vio && !reduce) vio.observe(v); }); }
  videos(document);

  /* ---------- Scroll: header shadow + zipper progress ---------- */
  var zip = $('.lv-zip');
  var ticking = false, lastY = window.scrollY, moveT;
  function onScroll() {
    ticking = false;
    var y = window.scrollY;
    document.body.classList.toggle('is-scrolled', y > 10);
    if (zip) {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, y / max) : 0;
      zip.style.setProperty('--p', p.toFixed(4));
      zip.classList.toggle('is-on', y > 200);
      zip.classList.toggle('is-end', max - y < 700);
      if (Math.abs(y - lastY) > 2) {
        zip.classList.toggle('is-up', y < lastY);
        zip.classList.add('is-moving');
        clearTimeout(moveT); moveT = setTimeout(function () { zip.classList.remove('is-moving'); }, 180);
      }
      lastY = y;
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* ---------- Warmth: cursor glow + paw trail + hero ears look at the cursor ---------- */
  if (finePointer && !reduce) {
    var glow = LV.fx.glow ? $('.lv-glow') : null;
    var gx = 0, gy = 0, tx = 0, ty = 0, raf = null;
    var last = null, step = 0;
    var heroEars = $$('.lv-hero__art .lv-ear');
    var heroArt = $('.lv-hero__art');
    function loop() {
      gx += (tx - gx) * 0.12; gy += (ty - gy) * 0.12;
      if (glow) glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
      raf = Math.abs(tx - gx) + Math.abs(ty - gy) > 0.5 ? requestAnimationFrame(loop) : null;
    }
    window.addEventListener('pointermove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (glow) { glow.classList.add('is-on'); if (!raf) raf = requestAnimationFrame(loop); }
      if (LV.fx.paws) {
        if (!last) last = { x: tx, y: ty };
        var dx = tx - last.x, dy = ty - last.y;
        if (dx * dx + dy * dy > 150 * 150 && !e.target.closest('input, textarea, select, .lv-drawer, .lv-modal')) {
          var ang = Math.atan2(dy, dx) * 180 / Math.PI + 90;
          var side = (step++ % 2 ? 1 : -1) * 9;
          var nx = -Math.sin(ang * Math.PI / 180) * side, ny = Math.cos(ang * Math.PI / 180) * side;
          var p = document.createElement('span');
          p.className = 'lv-paw-print';
          p.style.left = (tx + nx) + 'px'; p.style.top = (ty + ny) + 'px';
          p.style.setProperty('--r', ang + 'deg');
          p.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor"><ellipse cx="12" cy="15.6" rx="4.6" ry="3.9"/><ellipse cx="5.6" cy="10.6" rx="1.9" ry="2.3"/><ellipse cx="9.4" cy="6.8" rx="1.9" ry="2.4"/><ellipse cx="14.6" cy="6.8" rx="1.9" ry="2.4"/><ellipse cx="18.4" cy="10.6" rx="1.9" ry="2.3"/></svg>';
          document.body.appendChild(p);
          setTimeout(function () { p.remove(); }, 1700);
          last = { x: tx, y: ty };
        }
      }
      if (heroArt && heroEars.length) {
        var r = heroArt.getBoundingClientRect();
        var cx = (tx - (r.left + r.width / 2)) / window.innerWidth;
        var cy = (ty - (r.top + r.height / 3)) / window.innerHeight;
        heroEars.forEach(function (ear, i) { ear.style.rotate = ((cx * 18) + (i ? -cy : cy) * 10).toFixed(2) + 'deg'; });
      }
    }, { passive: true });
    document.addEventListener('pointerleave', function () { if (glow) glow.classList.remove('is-on'); });
  }

  /* ---------- Announcement rotator ---------- */
  $$('[data-lv-announce]').forEach(function (bar) {
    var msgs = $$('.lv-announce__msg', bar);
    if (msgs.length < 2) { if (msgs[0]) msgs[0].classList.add('is-on'); return; }
    var i = 0, t = (parseInt(bar.getAttribute('data-speed'), 10) || 4) * 1000;
    msgs[0].classList.add('is-on');
    setInterval(function () {
      var cur = msgs[i];
      cur.classList.remove('is-on'); cur.classList.add('is-out');
      setTimeout(function () { cur.classList.remove('is-out'); }, 700);
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, t);
  });

  /* ---------- Delivery estimate (real business days) ---------- */
  function addBiz(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  $$('[data-lv-eta]').forEach(function (el) {
    var proc = +el.getAttribute('data-proc') || 0, a = +el.getAttribute('data-min') || 3, b = +el.getAttribute('data-max') || 7;
    var now = new Date();
    var f = function (d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); };
    el.textContent = f(addBiz(now, proc + a)) + ' – ' + f(addBiz(now, proc + b));
  });

  /* ---------- Drawers / modals ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('[data-lv-close], button, a, input');
    setTimeout(function () { if (f) f.focus({ preventScroll: true }); }, 60);
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.lv-drawer.is-open, .lv-menu.is-open, .lv-modal.is-open')) document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-lv-open]');
    if (o) {
      var target = document.getElementById(o.getAttribute('data-lv-open'));
      if (target) { e.preventDefault(); openLayer(target); }
      return;
    }
    // "Size guide" links: when the page has no size section, the size popup opens instead
    var sz = e.target.closest('a[href*="#size"]'), szModal = document.getElementById('lv-size-modal');
    if (sz && szModal && !document.getElementById('size')) {
      var u = new URL(sz.href, window.location.href);
      if (u.pathname === window.location.pathname) { e.preventDefault(); closeLayer(sz.closest('.lv-drawer, .lv-menu')); openLayer(szModal); return; }
    }
    var c = e.target.closest('[data-lv-close]');
    if (c) {
      e.preventDefault(); closeLayer(c.closest('.lv-drawer, .lv-menu, .lv-modal'));
      // a closing link that points at the page (e.g. "Pick another" -> #buy): go there once the layer is shut
      var h = c.getAttribute('href'), t = h && h.charAt(0) === '#' && h.length > 1 ? document.getElementById(h.slice(1)) : null;
      if (t) setTimeout(function () { t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' }); }, 250);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') $$('.lv-drawer.is-open, .lv-menu.is-open, .lv-modal.is-open').forEach(closeLayer);
  });

  /* ---------- Burst of hearts & paws ---------- */
  function burst(el, acorns) {
    if (reduce || !el) return;
    var r = el.getBoundingClientRect();
    var shapes = [
      '<svg viewBox="0 0 24 24"><path d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10z" fill="#F2A6B3"/></svg>',
      '<svg viewBox="0 0 24 24" fill="#B8743A"><ellipse cx="12" cy="15.6" rx="4.6" ry="3.9"/><ellipse cx="5.6" cy="10.6" rx="1.9" ry="2.3"/><ellipse cx="9.4" cy="6.8" rx="1.9" ry="2.4"/><ellipse cx="14.6" cy="6.8" rx="1.9" ry="2.4"/><ellipse cx="18.4" cy="10.6" rx="1.9" ry="2.3"/></svg>',
      '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="6" fill="#E2A866"/></svg>'
    ];
    if (acorns) shapes[2] = shapes[1] = '<svg viewBox="0 0 24 24"><path d="M7 11.5h10c0 5-2.4 8.8-5 9.5-2.6-.7-5-4.5-5-9.5z" fill="#E2A866"/><path d="M5.5 11.5c0-3.4 3-5.6 6.5-5.6s6.5 2.2 6.5 5.6z" fill="#6B4532"/></svg>';
    for (var i = 0; i < 16; i++) {
      var s = document.createElement('span');
      s.className = 'lv-burst';
      s.innerHTML = shapes[i % 3];
      var a = Math.random() * Math.PI * 2, d = 60 + Math.random() * 90;
      s.style.left = (r.left + r.width / 2) + 'px'; s.style.top = (r.top + r.height / 2) + 'px';
      s.style.setProperty('--dx', Math.cos(a) * d + 'px');
      s.style.setProperty('--dy', (Math.sin(a) * d - 50) + 'px');
      s.style.setProperty('--rot', (Math.random() * 120 - 60) + 'deg');
      document.body.appendChild(s);
      setTimeout(function (n) { n.remove(); }.bind(null, s), 1200);
    }
  }

  /* ---------- Cart ---------- */
  var drawerId = 'lv-cart';
  function cartSection() { var d = document.getElementById(drawerId); return d ? d.getAttribute('data-section') : null; }
  function setCount(n) {
    $$('[data-lv-count]').forEach(function (c) { c.textContent = n > 0 ? n : ''; c.setAttribute('data-n', n); c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); });
  }
  function renderDrawer(html) {
    var drawer = document.getElementById(drawerId);
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-lv-cart-inner]');
    var cur = drawer.querySelector('[data-lv-cart-inner]');
    if (fresh && cur) { cur.innerHTML = fresh.innerHTML; observe(cur); }
    var n = doc.querySelector('[data-lv-cart-count]');
    if (n) setCount(+n.getAttribute('data-lv-cart-count'));
  }
  function refreshDrawer() {
    var id = cartSection();
    if (!id) return Promise.resolve();
    return fetch(root + '?sections=' + id).then(function (r) { return r.json(); }).then(function (j) { renderDrawer(j[id]); });
  }
  function cartPost(url, body) {
    var id = cartSection();
    if (id) body.sections = id;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { if (j.sections && id) renderDrawer(j.sections[id]); return j; });
  }
  LV.cart = { open: function () { openLayer(document.getElementById(drawerId)); }, refresh: refreshDrawer };

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-lv-qty]');
    if (q) {
      var line = +q.getAttribute('data-line'), cur = +q.getAttribute('data-q') || 0, act = q.getAttribute('data-lv-qty');
      var next = act === 'remove' ? 0 : Math.max(0, cur + (+act));
      q.disabled = true;
      cartPost((LV.routes.cart_change || '/cart/change') + '.js', { line: line, quantity: next }).catch(function () {}).then(function () { q.disabled = false; });
      return;
    }
    var addv = e.target.closest('[data-lv-add-variant]');
    if (addv) {
      addv.classList.add('is-loading');
      cartPost((LV.routes.cart_add || '/cart/add') + '.js', { items: [{ id: +addv.getAttribute('data-lv-add-variant'), quantity: 1 }] })
        .then(function () { burst(addv); })
        .catch(function () { refreshDrawer(); });
      return;
    }
    var up = e.target.closest('[data-lv-upgrade]');
    if (up) {
      up.classList.add('is-loading');
      var props = {};
      try { props = JSON.parse(up.getAttribute('data-props') || '{}'); } catch (err) {}
      cartPost((LV.routes.cart_change || '/cart/change') + '.js', { line: +up.getAttribute('data-line'), quantity: 0 })
        .then(function () { return cartPost((LV.routes.cart_add || '/cart/add') + '.js', { items: [{ id: +up.getAttribute('data-lv-upgrade'), quantity: 1, properties: props }] }); })
        .then(function () { burst(up); })
        .catch(function () { refreshDrawer(); });
    }
  });
  var noteT;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-lv-note]')) return;
    clearTimeout(noteT);
    var v = e.target.value;
    noteT = setTimeout(function () {
      fetch((LV.routes.cart_update || '/cart/update') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) });
    }, 500);
  });

  /* ---------- Animal kinds: the buy button dresses up as the last animal picked ---------- */
  var KINDS = ['squirrel', 'teddy', 'mouse', 'bear', 'kitty', 'night'];
  function kindOf(val) {
    var v = (val || '').toLowerCase();
    if (/squirrel|acorn|duo/.test(v)) return 'squirrel';
    if (/mouse|mice/.test(v)) return 'mouse';
    if (/teddy|bear/.test(v)) return 'teddy';
    if (/kitty|cat|kitten/.test(v)) return 'kitty';
    return 'bear';
  }
  function setKind(scope, kind) {
    $$('[data-lv-kind-btn]', scope).forEach(function (b) {
      if (b.classList.contains('lv-btn--' + kind)) return;
      KINDS.forEach(function (k) { b.classList.remove('lv-btn--' + k); });
      b.classList.add('lv-btn--' + kind);
      $$('.lv-btn__ears .lv-ear', b).forEach(function (e) { KINDS.forEach(function (k) { e.classList.remove('lv-ear--' + k); }); e.classList.add('lv-ear--' + kind); });
      b.classList.remove('is-swap'); void b.offsetWidth; b.classList.add('is-swap');
    });
    var ears = $('.lv-gal__main > .lv-ears', scope);
    if (ears) {
      $$('.lv-ear', ears).forEach(function (e) { KINDS.forEach(function (k) { e.classList.remove('lv-ear--' + k); }); e.classList.add('lv-ear--' + kind); });
      var tail = $('.lv-tail', ears);
      if (!tail && kind === 'squirrel') { tail = document.createElement('i'); tail.className = 'lv-tail'; ears.appendChild(tail); }
      if (tail) tail.hidden = kind !== 'squirrel';
    }
  }
  LV.kindOf = kindOf;

  /* ---------- Product form ---------- */
  function initProduct(sec) {
    var dataEl = $('[data-lv-product-json]', sec);
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = $('form[data-lv-product]', sec);
    var idInput = $('input[name="id"]', form);
    var btn = $('[data-lv-add]', sec);
    var btnLabel = btn ? $('.lv-btn__label', btn) : null;
    var second = $('[data-lv-second]', sec);
    var secondSel = second ? $('select', second) : null;
    var duoKey = (sec.getAttribute('data-duo') || 'duo').toLowerCase();
    var sizeIdx = +sec.getAttribute('data-size-index');
    var sticky = $('[data-lv-sticky]', sec);
    var grow = $('[data-lv-grow]', sec), growInput = grow ? $('[data-lv-grow-input]', grow) : null, growVariant = null;
    var buyLabel = btn ? (btn.getAttribute('data-label') || LV.strings.add) : LV.strings.add;
    var styleIdx = -1;
    product.options.forEach(function (o, i) { if ($('input[data-opt="' + i + '"][data-kind]', form)) styleIdx = i; });
    var packEl = $('[data-lv-pack]', sec), packList = packEl ? $('[data-lv-pack-list]', packEl) : null, addMore = $('[data-lv-addmore]', sec), pack = [];
    var packLabel = btn ? (btn.getAttribute('data-pack-label') || 'Buy [n] now · [total]') : '';
    var stickyImg = $('[data-lv-sticky-img]', sec);
    // Bundle & save: 1 / 2 / 3 onesies (the store's automatic discounts take the same amounts off at checkout)
    var tiersEl = $('[data-lv-tiers]', sec), packSaving = $('[data-lv-pack-saving]', sec);
    var d2 = tiersEl ? +tiersEl.getAttribute('data-d2') || 0 : 0, d3 = tiersEl ? +tiersEl.getAttribute('data-d3') || 0 : 0;
    var nextLabel = btn ? (btn.getAttribute('data-next-label') || 'Next: onesie [i] of [n]') : '';
    var pickLabel = btn ? (btn.getAttribute('data-pick-label') || 'Choose onesie [i] of [n]') : '';
    // Simple bundle: 1 / 2 / 3 pills, onesie 1 = buy box picks, onesies 2-3 = one row (animal + size) each
    var sbEl = $('[data-lv-sb]', sec), sbRowsWrap = $('[data-lv-sb-rows]', sec);
    var sbD2 = sbEl ? +sbEl.getAttribute('data-d2') || 0 : 0, sbD3 = sbEl ? +sbEl.getAttribute('data-d3') || 0 : 0;
    function sbN() { var c = sbEl && $('input[data-lv-sb-n]:checked', sbEl); return c ? +c.value : 1; }
    // extra onesies (rows 2-3); row 1 is the buy box itself
    function sbRows() { return $$('[data-lv-sbrow]', sec).filter(function (r) { var k = +r.getAttribute('data-lv-sbrow'); return k > 1 && k <= sbN(); }); }
    var sbMain = $('[data-sb-main]', sec);
    function optFieldset(i) { var inp = $('input[data-opt="' + i + '"]', form); return inp ? inp.closest('fieldset') : null; }
    var sbLast = null;
    function sbShow() {
      if (!sbEl) return;
      var n = sbN();
      if (n < 2) sbLast = null;
      sbRowsWrap.hidden = n < 2;
      $$('[data-lv-sbrow]', sec).forEach(function (r) { r.hidden = +r.getAttribute('data-lv-sbrow') > n; });
      // 2 or 3 onesies: the big animal cards and size chips step aside, onesie 1 becomes a row like the others
      [optFieldset(styleIdx), optFieldset(sizeIdx)].forEach(function (fs) { if (fs) fs.hidden = n > 1; });
      if (sbMain) {
        var o = selected();
        if (o[styleIdx]) sbSetStyle(sbMain, o[styleIdx]);
        $$('[data-sb-size]', sbMain).forEach(function (i) { i.checked = !!o[sizeIdx] && i.value === o[sizeIdx]; });
      }
      // Duo: both animals peek over the buy button
      $$('[data-lv-kind-btn]', sec).forEach(function (b) { b.classList.toggle('is-duo', n > 1); });
      var ab = $('[data-lv-add-bag]', sec), of = $('.lv-offer', sec);
      if (ab) ab.hidden = n > 1;
      if (of) of.hidden = n > 1;
    }
    function sbStyle(row) { var c = $('[data-sb-style]:checked', row); return c ? c.value : ''; }
    function sbSetStyle(row, val) { $$('[data-sb-style]', row).forEach(function (i) { i.checked = i.value === val; }); sbName(row); }
    function sbName(row) { var n = $('[data-sb-name]', row); if (n) n.textContent = sbStyle(row) ? '· ' + sbStyle(row) : ''; }
    function sbVariant(st, sz) { return product.variants.find(function (x) { return x.options[styleIdx] === st && x.options[sizeIdx] === sz; }); }
    // the other onesies, or null (and the missing size is pointed out) when a row is not ready
    function sbItems() {
      var out = [];
      for (var i = 0, rows = sbRows(); i < rows.length; i++) {
        var r = rows[i], st = sbStyle(r), szSel = $('[data-sb-size]:checked', r), v = szSel ? sbVariant(st, szSel.value) : null;
        if (!v || !v.available) {
          r.classList.remove('is-need'); void r.offsetWidth; r.classList.add('is-need');
          r.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
          return null;
        }
        r.classList.remove('is-need');
        out.push({ id: v.id, quantity: 1, properties: {} });
      }
      return out;
    }
    if (sbMain) {
      // row 1 drives the buy box radios (gallery, price, button colour follow)
      $$('[data-sb-style]', sbMain).forEach(function (rb) { rb.addEventListener('change', function (e) {
        e.stopPropagation();
        sbName(sbMain);
        sbLast = e.target.value;
        var r = $$('input[data-opt="' + styleIdx + '"]', form).filter(function (i) { return i.value === e.target.value; })[0];
        if (r) { r.checked = true; update(true); }
      }); });
      $$('[data-sb-size]', sbMain).forEach(function (rb) { rb.addEventListener('change', function (e) {
        e.stopPropagation();
        $$('input[data-opt="' + sizeIdx + '"]', form).forEach(function (i) { i.checked = i.value === e.target.value; });
        sbMain.classList.remove('is-need');
        update(true);
      }); });
    }
    // tapping an animal that is already selected still brings its photos back to the front
    $$('input[data-opt="' + styleIdx + '"], [data-sb-style]', form).forEach(function (rb) {
      rb.addEventListener('click', function () {
        if (rb.hasAttribute('data-sb-style')) sbLast = rb.value;
        setKind(sec, kindOf(rb.value));
        if (sec._lvFilter) sec._lvFilter(rb.value, true, true);
      });
    });
    if (sbEl) {
      sbShow();
      $$('[data-lv-sbrow]', sec).forEach(sbName);
      $$('[data-lv-sbrow]:not([data-sb-main]) [data-sb-style]', sec).forEach(function (rb) { rb.addEventListener('change', function () { sbName(rb.closest('[data-lv-sbrow]')); sbLast = rb.value; }); });
      $$('[data-sb-size]', sec).forEach(function (sel) { sel.addEventListener('change', function () { sel.closest('[data-lv-sbrow]').classList.remove('is-need'); }); });
      // simple offer cards (animal / animal / Duo): the card also sets the animal of each onesie
      var sbPick = function (rb) {
        var picks = (rb.getAttribute('data-sb-pick') || '').split('|');
        $$('input[data-opt="' + styleIdx + '"]', form).forEach(function (i) { i.checked = i.value === picks[0]; });
        $$('[data-lv-sbrow]', sec).forEach(function (row) { var p = picks[+row.getAttribute('data-lv-sbrow') - 1]; if (p) sbSetStyle(row, p); });
        var duoPics = picks.length > 1 && $('.lv-gal__slide[data-style="duo"]', sec);
        sbLast = duoPics ? 'Duo' : picks[picks.length - 1];
        return picks[0];
      };
      $$('input[data-sb-pick]', sbEl).forEach(function (rb) {
        rb.addEventListener('change', function () {
          var first = sbPick(rb), show = sbN() > 1 ? sbLast : first;
          update(true);
          setKind(sec, kindOf(show));
          if (sec._lvFilter) sec._lvFilter(show, true, true);
        });
      });
      // the Duo opens picked; a home page link (?style=Little Mouse) opens on that animal's own card
      var sbWant = new URLSearchParams(window.location.search).get('style');
      var sbStart = (sbWant && $$('input[data-sb-pick][value="1"]', sbEl).filter(function (i) { return i.getAttribute('data-sb-pick').toLowerCase().indexOf(sbWant.toLowerCase()) > -1; })[0]) || $('input[data-sb-pick]:checked', sbEl);
      if (sbStart) { sbStart.checked = true; sbPick(sbStart); sbShow(); if (sbN() > 1 && sec._lvFilter) sec._lvFilter(sbLast, false, true); }
    }
    function tierN() { var c = tiersEl && $('input[data-lv-tier]:checked', tiersEl); return c ? +c.value : 1; }
    function mediaSrc(v, w) {
      var m = v && v.featured_media && v.featured_media.preview_image;
      if (!m || !m.src) return '';
      return m.src + (m.src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    // ?style=Little%20Mouse from the home page picks the animal (never the size)
    try {
      var want = new URL(window.location.href).searchParams.get('style');
      if (want && styleIdx > -1) {
        var hit = $$('input[data-opt="' + styleIdx + '"]', form).filter(function (i) { return i.value.toLowerCase().indexOf(want.toLowerCase()) > -1; })[0];
        if (hit) hit.checked = true;
      }
      var params = new URL(window.location.href).searchParams, wantSize = params.get('size'), wantB = +params.get('bundle') || 0;
      if (wantSize && sizeIdx > -1) {
        var sh = $$('input[data-opt="' + sizeIdx + '"]', form).filter(function (i) { return i.value === wantSize; })[0];
        if (sh && !sh.disabled) sh.checked = true; else wantSize = null;
      }
      var tierHit = wantB > 1 && $('[data-lv-tiers] input[data-lv-tier][value="' + Math.min(3, wantB) + '"]', sec);
      if (tierHit) tierHit.checked = true;
      var autoAdd = !!(tierHit && wantSize);
    } catch (err) {}
    function updateGrow(v) {
      if (!grow) return;
      // simple bundle: the grow pack is only offered with "1 onesie" (2 / 3 have their own rows)
      if (sbEl && sbN() > 1) { grow.hidden = true; if (growInput) growInput.checked = false; growVariant = null; return; }
      growVariant = null;
      if (v && sizeIdx > -1) {
        var order = [];
        product.variants.forEach(function (x) { if (order.indexOf(x.options[sizeIdx]) < 0) order.push(x.options[sizeIdx]); });
        var next = order[order.indexOf(v.options[sizeIdx]) + 1];
        if (next) growVariant = product.variants.find(function (x) { return x.available && x.options.every(function (o, i) { return i === sizeIdx ? o === next : o === v.options[i]; }); }) || null;
      }
      grow.hidden = !growVariant;
      if (!growVariant) { if (growInput) growInput.checked = false; return; }
      $('[data-lv-grow-size]', grow).textContent = growVariant.options[sizeIdx];
      var th = +grow.getAttribute('data-threshold') || 0;
      var ship = $('[data-lv-grow-ship]', grow), inBundle = $('[data-lv-grow-bundle]', grow);
      if (tiersEl) {
        // the next size is one more onesie in the bundle: show what it really adds at bundle price
        var base = packTotal(v, true), more = bundleTotal(base.n + 1, base.raw + growVariant.price);
        $('[data-lv-grow-price]', grow).textContent = '+' + money(more - base.total);
        if (ship) ship.hidden = true;
        if (inBundle) inBundle.hidden = false;
      } else if (sbEl && sbD2 > 0) {
        // with 1 onesie + the next size, the 2-onesie price applies in the bag: show what it really adds
        $('[data-lv-grow-price]', grow).textContent = '+' + money(growVariant.price - sbD2);
        if (ship) ship.hidden = true;
        if (inBundle) inBundle.hidden = false;
      } else {
        $('[data-lv-grow-price]', grow).textContent = money(growVariant.price);
        if (ship) ship.hidden = !(th > 0 && v.price < th && v.price + growVariant.price >= th);
        if (inBundle) inBundle.hidden = true;
      }
    }

    function selected() {
      return product.options.map(function (_, i) {
        var c = $('input[data-opt="' + i + '"]:checked', form);
        return c ? c.value : null;
      });
    }
    function find(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }) && opts.every(function (o) { return o !== null; }); });
    }
    function isDuo(opts) { return opts.some(function (o) { return o && o.toLowerCase().indexOf(duoKey) > -1; }); }

    function bundleOff(n) { return !tiersEl ? 0 : n >= 3 ? d3 : n >= 2 ? d2 : 0; }
    function bundleTotal(n, raw) { return Math.max(0, raw - bundleOff(n)); }
    // noGrow: leave the ticked next-size onesie out (used to price the grow pack itself)
    function packTotal(v, noGrow) {
      var cur = v && v.available ? 1 : 0, n = pack.length + cur;
      var raw = pack.reduce(function (t, it) { return t + it.price; }, 0) + (cur ? v.price : 0);
      if (!noGrow && cur && growInput && growInput.checked && growVariant) { n++; raw += growVariant.price; }
      return { n: n, cur: cur, raw: raw, off: bundleOff(n), total: bundleTotal(n, raw) };
    }
    function renderPack(v) {
      if (!packEl) return;
      packEl.hidden = pack.length === 0;
      packList.innerHTML = '';
      pack.forEach(function (it, i) {
        var li = document.createElement('li');
        li.className = 'lv-pack__item';
        li.innerHTML = (it.img ? '<img src="' + it.img + '" alt="" width="46" height="56">' : '') +
          '<span class="lv-pack__txt"><b></b><small></small></span>' +
          '<button type="button" class="lv-pack__rm" aria-label="Remove"><svg class="lv-i" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
        $('b', li).textContent = it.style || it.title;
        $('small', li).textContent = it.size + ' · ' + money(it.price);
        $('.lv-pack__rm', li).addEventListener('click', function () { pack.splice(i, 1); update(false); });
        packList.appendChild(li);
      });
      var t = packTotal(v);
      $('[data-lv-pack-n]', packEl).textContent = t.n;
      $('[data-lv-pack-total]', packEl).textContent = money(t.total);
      if (packSaving) { packSaving.hidden = !t.off; $('b', packSaving).textContent = '\u2212' + money(t.off); }
    }
    // Bundle guide: one slot per onesie in the chosen bundle, filled as the parent picks each one
    var guide = tiersEl && $('[data-lv-bguide]', tiersEl);
    function renderGuide(v) {
      if (!guide) return;
      var N = tierN(), t = packTotal(v);
      guide.hidden = N < 2;
      if (N < 2) return;
      var slots = $('[data-lv-bguide-slots]', guide), items = pack.slice();
      if (t.cur) items.push({ img: mediaSrc(v, 120), cur: true });
      if (t.cur && growInput && growInput.checked && growVariant) items.push({ img: mediaSrc(growVariant, 120) || mediaSrc(v, 120), cur: true });
      slots.innerHTML = '';
      for (var k = 0; k < Math.max(N, items.length); k++) {
        var li = document.createElement('li'), it = items[k];
        li.className = 'lv-bguide__slot' + (it ? ' is-full' : '') + (it && it.cur ? ' is-cur' : '') + (!it && k === items.length ? ' is-next' : '');
        li.innerHTML = it && it.img ? '<img src="' + it.img + '" alt="">' : '<span>' + (k + 1) + '</span>';
        slots.appendChild(li);
      }
      var txt = $('[data-lv-bguide-txt]', guide), msg;
      if (t.n >= N) msg = (guide.getAttribute('data-done') || '').replace('[total]', money(t.total)).replace('[save]', money(t.off));
      else if (t.cur) msg = guide.getAttribute('data-ready') || '';
      else msg = guide.getAttribute('data-step') || '';
      txt.textContent = msg.replace(/\[i\]/g, t.cur ? t.n : t.n + 1).replace(/\[n\]/g, Math.max(N, t.n));
      guide.classList.toggle('is-done', t.n >= N);
    }
    function buyText(v) {
      if (sbEl && sbN() === 1 && v && v.available && growInput && growInput.checked && growVariant) {
        return packLabel.replace('[n]', 2).replace('[total]', money(v.price + growVariant.price - sbD2));
      }
      if (sbEl && sbN() > 1) {
        var n = sbN(), unit = (v || product.variants[0]).price;
        return packLabel.replace('[n]', n).replace('[total]', money(unit * n - (n >= 3 ? sbD3 : sbD2)));
      }
      var t = packTotal(v), N = tierN();
      if (tiersEl && N > 1 && t.n < N) return (t.cur ? nextLabel : pickLabel).replace('[i]', t.n + 1).replace('[n]', N);
      if (t.n <= 1 && !pack.length) return buyLabel;
      return packLabel.replace('[n]', t.n).replace('[total]', money(t.total));
    }

    function update(fromUser) {
      var opts = selected();
      var v = find(opts);
      // availability per size chip for the chosen style
      if (sizeIdx > -1) {
        $$('input[data-opt="' + sizeIdx + '"]', form).forEach(function (inp) {
          var test = opts.slice(); test[sizeIdx] = inp.value;
          var match = product.variants.find(function (x) { return x.options.every(function (o, i) { return test[i] === null || o === test[i]; }); });
          inp.disabled = !match || !match.available;
        });
      }
      $$('[data-lv-opt-value]', form).forEach(function (s) { var i = +s.getAttribute('data-lv-opt-value'); s.textContent = opts[i] || ''; });
      var duoNow = isDuo(opts);
      var sn = sizeIdx > -1 ? $('fieldset[data-lv-size-group] [data-lv-size-name]', form) : null;
      if (sn) sn.textContent = duoNow ? sn.getAttribute('data-duo-label') : sn.getAttribute('data-lv-size-name');
      if (second) {
        var duo = duoNow;
        second.hidden = !duo;
        if (secondSel) { secondSel.disabled = !duo; if (duo && !secondSel.getAttribute('data-touched') && sizeIdx > -1 && opts[sizeIdx]) secondSel.value = opts[sizeIdx]; }
      }
      var priceEls = $$('[data-lv-price]', sec), cmpEls = $$('[data-lv-compare]', sec), saveEls = $$('[data-lv-save]', sec), eachEls = $$('[data-lv-each]', sec);
      // price follows the chosen style even before a size is picked
      var pv = v || product.variants.find(function (x) { return x.options.every(function (o, i) { return opts[i] === null || o === opts[i]; }); });
      if (pv) {
        priceEls.forEach(function (p) { p.textContent = money(pv.price); });
        var on = pv.compare_at_price && pv.compare_at_price > pv.price;
        cmpEls.forEach(function (c) { c.hidden = !on; if (on) c.textContent = money(pv.compare_at_price); });
        saveEls.forEach(function (s) { s.hidden = !on; if (on) s.textContent = (LV.strings.save || 'Save ') + money(pv.compare_at_price - pv.price); });
        eachEls.forEach(function (s) { s.hidden = !duoNow; if (duoNow) s.textContent = money(Math.round(pv.price / 2)) + ' ' + (s.getAttribute('data-each') || 'each'); });
      }
      sbShow();
      // the photos and button follow the last animal tapped (in any bundle row), else the buy box choice
      var showStyle = sbEl && sbN() > 1 && sbLast ? sbLast : opts[styleIdx];
      if (styleIdx > -1 && showStyle) {
        setKind(sec, kindOf(showStyle));
        if (sec._lvFilter) sec._lvFilter(showStyle, fromUser);
      }
      var jump = showStyle === opts[styleIdx];
      updateGrow(v);
      // size picked: drop the "choose a size" message
      var sg = sizeIdx > -1 ? $('[data-lv-size-group]', form) : null;
      if (sg) {
        var hasSize = !!opts[sizeIdx], req = $('[data-lv-req]', sg), nd = $('[data-lv-need]', sg);
        if (req) req.hidden = hasSize;
        if (hasSize) { if (nd) nd.hidden = true; sg.classList.remove('is-need'); }
      }
      if (grow) {
        var on = $('[data-lv-grow-on]', grow);
        if (on) { on.hidden = !(growInput && growInput.checked && !grow.hidden); on.textContent = (on.getAttribute('data-text') || '').replace('[i]', packTotal(v).n); }
      }
      renderPack(v);
      renderGuide(v);
      if (addMore) {
        addMore.disabled = !!(v && !v.available);
        var tn = packTotal(v).n;
        addMore.hidden = !!(tiersEl && tierN() > 1 && tn < tierN());
        // one more onesie unlocks the bigger bundle: say what it really costs
        var al = $('span', addMore), up = addMore.getAttribute('data-upsell');
        if (!al.getAttribute('data-was')) al.setAttribute('data-was', al.textContent);
        if (!addMore.classList.contains('is-flash')) al.textContent = tiersEl && up && tn === 2 && d3 > d2 ? up.replace('[price]', money(v ? v.price - (d3 - d2) : 0)) : al.getAttribute('data-was');
      }
      if (v) {
        idInput.value = v.id;
        if (btn) {
          btn.disabled = !v.available && !pack.length;
          btnLabel.textContent = v.available || pack.length ? buyText(v) : LV.strings.soldout;
        }
        if (fromUser) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
          if (v.featured_media && jump) goToMedia(sec, v.featured_media.id);
        }
      } else if (btn) {
        btn.disabled = false;
        btnLabel.textContent = sizeIdx > -1 && !opts[sizeIdx] ? buyText(null) : LV.strings.soldout;
        if (fromUser && jump && pv && pv.featured_media) goToMedia(sec, pv.featured_media.id);
      }
      updateGrow(v);
      if (sticky) {
        var sp = $('[data-lv-sticky-price]', sticky);
        if (sp && pv) sp.textContent = money(pv.price);
        var sv = $('[data-lv-sticky-variant]', sticky);
        if (sv) sv.textContent = pack.length ? pack.map(function (it) { return it.style; }).concat(v && v.available && styleIdx > -1 ? [opts[styleIdx]] : []).join(' + ') : opts.filter(Boolean).join(' · ');
        if (sp && pack.length) sp.textContent = money(packTotal(v).total);
        var sl = $('[data-lv-sticky-go] .lv-btn__label', sticky);
        // the bar says what tapping it will do: pick a size, buy this size, or buy the bundle
        if (sl && btnLabel) {
          var multi = pack.length || (sbEl && sbN() > 1) || (growInput && growInput.checked && growVariant);
          if (multi) sl.textContent = btnLabel.textContent;
          else if (sizeIdx > -1 && !opts[sizeIdx]) sl.textContent = sticky.getAttribute('data-pick') || 'Pick a size';
          else if (v && v.available) sl.textContent = (sticky.getAttribute('data-buy') || 'Buy [size] now \u00b7 [price]').replace('[size]', opts[sizeIdx] || '').replace('[price]', money(v.price));
          else sl.textContent = btnLabel.textContent;
        }
        var si = stickyImg && mediaSrc(pv, 120);
        if (si) stickyImg.src = si;
      }
    }
    form.addEventListener('change', function (e) {
      if (secondSel && e.target === secondSel) { secondSel.setAttribute('data-touched', '1'); return; }
      if (tiersEl && e.target === growInput && growInput.checked) {
        // ticking the next size makes one more onesie: show the bundle it now unlocks
        var have = packTotal(find(selected())).n;
        if (have > tierN()) { var bt = $('input[data-lv-tier][value="' + Math.min(3, have) + '"]', tiersEl); if (bt) bt.checked = true; }
      }
      if (e.target.hasAttribute && e.target.hasAttribute('data-lv-tier') && growInput && growInput.checked) {
        // a smaller bundle chosen on purpose: the extra next-size onesie goes, so the choice sticks
        if (packTotal(find(selected())).n > tierN()) growInput.checked = false;
      }
      update(true);
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var opts = selected();
      var withCurrent = !(sizeIdx > -1 && !opts[sizeIdx]);
      if (!withCurrent && !pack.length) { askSize(); return; }
      var curV = withCurrent ? find(opts) : null;
      if (withCurrent && (!curV || !curV.available)) { if (!pack.length) return; withCurrent = false; }
      if (!btn || btn.disabled) return;
      var sbExtra = [];
      if (sbEl && sbN() > 1) { if (!withCurrent) { askSize(); return; } sbExtra = sbItems(); if (!sbExtra) return; }
      if (tiersEl && packTotal(withCurrent ? curV : null).n < tierN()) { if (withCurrent) addToPack(); else askSize(); return; }
      var fd = new FormData(form);
      var props = {};
      fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && val && !(secondSel && secondSel.disabled && key === secondSel.name)) props[m[1]] = val; });
      btn.classList.add('is-loading'); btnLabel.textContent = LV.strings.adding;
      var items = pack.map(function (it) { return { id: it.id, quantity: 1, properties: it.props }; });
      if (withCurrent) items.push({ id: +idInput.value, quantity: +(fd.get('quantity') || 1), properties: props });
      items = items.concat(sbExtra);
      if (withCurrent && growInput && growInput.checked && growVariant) items.push({ id: growVariant.id, quantity: 1, properties: { _bundle: 'Grow pack' } });
      var toCheckout = btn.hasAttribute('data-lv-checkout') && !forceBag;
      forceBag = false;
      cartPost((LV.routes.cart_add || '/cart/add') + '.js', { items: items })
        .then(function () {
          if (toCheckout) {
            btnLabel.textContent = LV.strings.to_checkout || LV.strings.added;
            burst(btn);
            setTimeout(function () { window.location.href = root + 'checkout'; }, 450);
            return;
          }
          btn.classList.remove('is-zipped'); void btn.offsetWidth; btn.classList.add('is-zipped');
          btnLabel.textContent = LV.strings.added;
          burst(btn);
          pack = [];
          setTimeout(function () { LV.cart.open(); btn.classList.remove('is-loading'); update(false); }, 650);
        })
        .catch(function (err) {
          btn.classList.remove('is-loading');
          btnLabel.textContent = (err && (err.description || err.message)) || LV.strings.error;
          setTimeout(function () { update(false); }, 2600);
        });
    });

    // "Add to bag & pick another": same checks as Buy it now, but the onesie goes to the bag and the bag opens
    var forceBag = false, addBag = $('[data-lv-add-bag]', sec);
    if (addBag) addBag.addEventListener('click', function () {
      var opts = selected();
      if (sizeIdx > -1 && !opts[sizeIdx]) { askSize(); return; }
      forceBag = true;
      burst(addBag);
      form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    // Buy tapped without a size: say so in words next to the sizes, not just a shake
    function askSize() {
      if (sbMain && sbN() > 1) {
        sbMain.classList.remove('is-need'); void sbMain.offsetWidth; sbMain.classList.add('is-need');
        sbMain.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      $$('input[data-opt="' + sizeIdx + '"]', form).forEach(function (i) { var c = i.closest('.lv-chip'); c.classList.remove('is-shake'); void c.offsetWidth; c.classList.add('is-shake'); });
      var g = $('[data-lv-size-group]', form);
      if (!g) return;
      var need = $('[data-lv-need]', g);
      if (need) {
        var N = tierN(), i = packTotal(null).n + 1;
        var txt = tiersEl && N > 1 ? (need.getAttribute('data-text-n') || '') : '';
        $('span', need).textContent = (txt || need.getAttribute('data-text') || '').replace('[i]', Math.min(i, N)).replace('[n]', N);
        need.hidden = false;
      }
      g.classList.remove('is-need'); void g.offsetWidth; g.classList.add('is-need');
      g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    }
    // Mix pack: keep this onesie aside, then pick the next animal + size
    if (addMore) addMore.addEventListener('click', function () { addToPack(addMore); });
    function addToPack(from) {
      from = from || btn;
      var opts = selected();
      if (sizeIdx > -1 && !opts[sizeIdx]) { askSize(); return; }
      var v = find(opts);
      if (!v || !v.available) return;
      var fd = new FormData(form), props = {};
      fd.forEach(function (val, key) { var m = key.match(/^properties\[(.+)\]$/); if (m && val && !(secondSel && secondSel.disabled && key === secondSel.name)) props[m[1]] = val; });
      pack.push({ id: v.id, price: v.price, title: v.title, style: styleIdx > -1 ? opts[styleIdx] : '', size: opts[sizeIdx] || '', img: mediaSrc(v, 120), props: props });
      if (growInput && growInput.checked && growVariant) pack.push({ id: growVariant.id, price: growVariant.price, title: growVariant.title, style: styleIdx > -1 ? growVariant.options[styleIdx] : '', size: growVariant.options[sizeIdx] || '', img: mediaSrc(growVariant, 120) || mediaSrc(v, 120), props: { _bundle: 'Grow pack' } });
      burst(from);
      if (from === addMore) {
        var lbl = $('span', addMore), was = lbl.getAttribute('data-was') || lbl.textContent;
        lbl.setAttribute('data-was', was);
        lbl.textContent = addMore.getAttribute('data-added') || was;
        addMore.classList.add('is-flash');
        setTimeout(function () { addMore.classList.remove('is-flash'); update(false); }, 1800);
      }
      // clear the size so the next onesie is a fresh pick (the animal stays: tap another one to mix)
      $$('input[data-opt="' + sizeIdx + '"]', form).forEach(function (i) { i.checked = false; });
      if (growInput) growInput.checked = false;
      // going past the chosen bundle moves up to the next one
      if (tiersEl && pack.length >= tierN() && tierN() < 3) { var nt = $('input[data-lv-tier][value="' + (pack.length + 1) + '"]', tiersEl); if (nt) nt.checked = true; }
      update(false);
      var st = styleIdx > -1 ? $('input[data-opt="' + styleIdx + '"]', form) : null;
      var target = st ? st.closest('fieldset') : null;
      if (target) target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }

    // Sticky add-to-cart
    if (sticky && btn) {
      // phones: the bar is there from the first second, whenever the real Buy button is off screen
      var stickyCheck = function () {
        var r = btn.getBoundingClientRect(), seen = r.bottom > 0 && r.top < window.innerHeight;
        sticky.classList.toggle('is-on', !seen && (r.top < 0 || window.innerWidth < 860));
      };
      window.addEventListener('scroll', stickyCheck, { passive: true });
      window.addEventListener('resize', stickyCheck);
      stickyCheck();
      $('[data-lv-sticky-go]', sticky).addEventListener('click', function () {
        var opts = selected();
        if (sizeIdx > -1 && !opts[sizeIdx] && !pack.length) { askSize(); }
        else form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }

    // Size finder inside the modal can pick the size chip
    sec.addEventListener('lv:size', function (e) {
      var inputs = $$('input[data-opt="' + sizeIdx + '"]', form);
      var inp = inputs[e.detail.index];
      if (inp && !inp.disabled) { inp.checked = true; update(true); }
    });
    update(false);
    if (autoAdd) addToPack(); // came from the size finder with a bundle: onesie 1 is in, the guide asks for the next
  }

  /* Gallery */
  function goToMedia(sec, mediaId) {
    var slide = $('[data-media-id="' + mediaId + '"]', sec);
    if (!slide) return;
    var track = slide.parentElement;
    track.scrollTo({ left: slide.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
  }
  function initGallery(sec) {
    var track = $('.lv-gal__track', sec);
    if (!track) return;
    var slides = $$('.lv-gal__slide', track), thumbs = $$('.lv-gal__thumbs button', sec), dots = $$('.lv-gal__dots i', sec);
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }); });
    function mark() {
      var vis = slides.filter(function (s) { return !s.hidden; });
      var cur = vis[Math.round(track.scrollLeft / track.clientWidth)] || vis[0];
      var i = slides.indexOf(cur);
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      slides.forEach(function (s, k) { var v = $('video', s); if (v) { if (k === i) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); } });
    }
    var st;
    track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(mark, 60); }, { passive: true });
    // photos follow the chosen animal; untagged media stay for every animal
    var shown = null;
    sec._lvFilter = function (style, animate, force) {
      var key = (style || '').toLowerCase();
      if (key === shown && !force) return;
      shown = key;
      slides.forEach(function (s, k) {
        var own = (s.getAttribute('data-style') || '').toLowerCase();
        var hide = !!own && own !== key;
        s.hidden = hide;
        if (thumbs[k]) thumbs[k].hidden = hide;
        if (dots[k]) dots[k].hidden = hide;
      });
      track.scrollTo({ left: 0, behavior: 'auto' });
      if (animate && !reduce) { track.classList.remove('is-swap'); void track.offsetWidth; track.classList.add('is-swap'); }
      mark();
    };
  }
  $$('[data-lv-pdp]').forEach(function (s) { initGallery(s); initProduct(s); });

  /* ---------- Photo viewer: tap a product photo -> full screen, swipe, tap to zoom, close with x / swipe down / Esc ---------- */
  (function () {
    var lb = null, track, count, lastFocus = null;
    function bigSrc(img) {
      var best = img.currentSrc || img.src, w = 0;
      (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
        var p = c.trim().split(/\s+/), cw = parseInt(p[1], 10) || 0;
        if (p[0] && cw > w) { w = cw; best = p[0]; }
      });
      return best;
    }
    function build() {
      lb = document.createElement('div');
      lb.className = 'lv-lb';
      lb.setAttribute('role', 'dialog');
      lb.setAttribute('aria-modal', 'true');
      lb.setAttribute('aria-label', 'Product photos');
      lb.innerHTML = '<div class="lv-lb__top"><span class="lv-lb__count" aria-live="polite"></span>' +
        '<button type="button" class="lv-lb__close" aria-label="Close"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
        '<div class="lv-lb__track"></div><p class="lv-lb__hint">Tap to zoom · swipe for more</p>';
      document.body.appendChild(lb);
      track = $('.lv-lb__track', lb); count = $('.lv-lb__count', lb);
      $('.lv-lb__close', lb).addEventListener('click', close);
      lb.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      var st;
      track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(mark, 60); }, { passive: true });
      // tap = zoom in / out where the finger is
      track.addEventListener('click', function (e) {
        var fig = e.target.closest('.lv-lb__fig'); if (!fig) return;
        var img = $('img', fig), zoomed = fig.classList.toggle('is-zoom');
        track.style.overflowX = zoomed ? 'hidden' : '';
        if (zoomed) {
          var r = img.getBoundingClientRect(), fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          requestAnimationFrame(function () { fig.scrollLeft = fx * fig.scrollWidth - fig.clientWidth / 2; fig.scrollTop = fy * fig.scrollHeight - fig.clientHeight / 2; });
        }
      });
      // swipe down (not zoomed) closes
      var y0 = null;
      track.addEventListener('touchstart', function (e) { y0 = e.touches.length === 1 && !$('.lv-lb__fig.is-zoom', lb) ? e.touches[0].clientY : null; }, { passive: true });
      track.addEventListener('touchend', function (e) { if (y0 !== null && e.changedTouches[0].clientY - y0 > 90) close(); y0 = null; }, { passive: true });
    }
    function mark() {
      var figs = $$('.lv-lb__fig', track), i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      count.textContent = (Math.min(i, figs.length - 1) + 1) + ' / ' + figs.length;
      figs.forEach(function (f, k) { if (k !== i && f.classList.contains('is-zoom')) { f.classList.remove('is-zoom'); track.style.overflowX = ''; } });
    }
    function open(imgs, start) {
      if (!lb) build();
      track.innerHTML = '';
      imgs.forEach(function (img) {
        var fig = document.createElement('figure');
        fig.className = 'lv-lb__fig';
        var big = document.createElement('img');
        big.src = bigSrc(img); big.alt = img.alt || ''; big.decoding = 'async';
        fig.appendChild(big); track.appendChild(fig);
      });
      lastFocus = document.activeElement;
      lb.classList.add('is-open');
      document.documentElement.classList.add('lv-lb-lock');
      track.scrollLeft = start * track.clientWidth;
      requestAnimationFrame(function () { track.scrollLeft = start * track.clientWidth; mark(); });
      mark();
      $('.lv-lb__close', lb).focus({ preventScroll: true });
    }
    function close() {
      if (!lb) return;
      lb.classList.remove('is-open');
      document.documentElement.classList.remove('lv-lb-lock');
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      var img = e.target.closest('.lv-gal__slide img');
      if (!img) return;
      var gal = img.closest('.lv-gal__track');
      var imgs = $$('.lv-gal__slide:not([hidden]) img', gal);
      var i = imgs.indexOf(img);
      if (i < 0) return;
      e.preventDefault();
      open(imgs, i);
    });
  })();
  if (window.location.hash === '#size' && !document.getElementById('size') && document.getElementById('lv-size-modal')) openLayer(document.getElementById('lv-size-modal'));

  /* ---------- Size finder ---------- */
  $$('[data-lv-finder]').forEach(function (f) {
    var rows = $$('tbody tr', f.closest('[data-lv-size-wrap]') || f);
    var data = rows.map(function (r) { return { lo: +r.getAttribute('data-lo'), hi: +r.getAttribute('data-hi'), age: +r.getAttribute('data-age'), label: r.getAttribute('data-label'), months: r.getAttribute('data-months') }; });
    var range = $('input[type="range"]', f), out = $('[data-lv-finder-val]', f), unit = $('[data-lv-finder-unit]', f);
    var resSize = $('[data-lv-finder-size]', f), resTxt = $('[data-lv-finder-txt]', f), pick = $('[data-lv-finder-pick]', f);
    var buy = $('[data-lv-finder-buy]', f), buyLabel = buy ? $('.lv-btn__label', buy) : null;
    var vmapEl = $('[data-lv-finder-variants]', f), fd = vmapEl ? JSON.parse(vmapEl.textContent) : null;
    var fsi = fd ? fd.size : -1, sizeVals = [];
    if (fd) fd.v.forEach(function (x) { if (sizeVals.indexOf(x.o[fsi]) < 0) sizeVals.push(x.o[fsi]); });
    var pdpHere = f.closest('[data-lv-pdp]') || $('[data-lv-pdp]');
    function fOpts() {
      if (!fd || !fd.v.length) return [];
      return fd.v[0].o.map(function (_, i) {
        if (i === fsi) return sizeVals[current];
        var c = $('input[data-fopt="' + i + '"]:checked', f);
        return c ? c.value : fd.v[0].o[i];
      });
    }
    function fVariant() { var o = fOpts(); return fd ? fd.v.find(function (x) { return x.o.every(function (v, i) { return v === o[i]; }); }) : null; }
    function fQty() { var q = $('input[data-fq]:checked', f); return q ? +q.value : 1; }
    function fStyle() { var o = fOpts(); for (var i = 0; i < o.length; i++) if (i !== fsi) return o[i]; return ''; }
    function setBuy() {
      if (!buy) return;
      $$('[data-lv-fopt-val]', f).forEach(function (sp) { var c = $('input[data-fopt="' + sp.getAttribute('data-lv-fopt-val') + '"]:checked', f); sp.textContent = c ? c.value : ''; });
      var st = fStyle(); if (st) setKind(f, kindOf(st));
      var v = fVariant(), n = fQty(), ok = !!(v && v.a);
      if (!fd) { buyLabel.textContent = (buy.getAttribute('data-label') || 'Buy [size] now').replace('[size]', data[current].label); return; }
      if (n > 1) buyLabel.textContent = (buy.getAttribute('data-bundle-label') || 'Get [n] for [total]').replace('[n]', n).replace('[total]', money(n === 2 ? fd.b2 : fd.b3));
      else buyLabel.textContent = ok ? (buy.getAttribute('data-label') || 'Buy [size] now').replace('[size]', data[current].label) + ' · ' + money(v.p) : LV.strings.soldout;
      buy.disabled = !ok;
    }
    // finder <-> buy box on the product page: same animal, same bundle
    function setRadio(scope, sel, val) { var r = $$(sel, scope).filter(function (i) { return i.value === String(val); })[0]; if (r && !r.checked) { r.checked = true; return r; } return null; }
    $$('input[data-fopt], input[data-fq]', f).forEach(function (i) { i.addEventListener('change', setBuy); });
    var pform = pdpHere && $('form[data-lv-product]', pdpHere);
    if (pform) pform.addEventListener('change', function () {
      $$('input[data-opt]:checked', pform).forEach(function (r) { var oi = r.getAttribute('data-opt'); if (+oi !== fsi) setRadio(f, 'input[data-fopt="' + oi + '"]', r.value); });
      var t = $('input[data-lv-tier]:checked', pform); if (t) setRadio(f, 'input[data-fq]', t.value);
      setBuy();
    });
    var mode = 'in', current = 0;
    function setMode(m) {
      mode = m;
      $$('[data-mode]', f).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false'); });
      if (m === 'age') { range.min = 0; range.max = 24; range.step = 1; range.value = 5; }
      else if (m === 'cm') { range.min = 46; range.max = 100; range.step = 1; range.value = 64; }
      else { range.min = 18; range.max = 39.5; range.step = 0.5; range.value = 25; }
      calc();
    }
    function calc() {
      var v = +range.value;
      var f2 = (v - range.min) / (range.max - range.min) * 100;
      range.style.setProperty('--f', f2 + '%');
      var cm = mode === 'cm' ? v : mode === 'in' ? v * 2.54 : null;
      var idx = 0, tip = '';
      if (cm !== null) {
        idx = data.length - 1;
        for (var i = 0; i < data.length; i++) { if (cm <= data[i].hi) { idx = i; break; } }
        if (data[idx] && data[idx].hi - cm < 2 && idx < data.length - 1) { idx++; tip = f.getAttribute('data-tip-up'); }
        out.textContent = mode === 'in' ? v.toFixed(1).replace('.0', '') : v;
        unit.textContent = mode === 'in' ? 'in' : 'cm';
      } else {
        idx = data.length - 1;
        for (var k = 0; k < data.length; k++) { if (v < data[k].age) { idx = k; break; } }
        out.textContent = v; unit.textContent = v === 1 ? 'month' : 'months';
        tip = f.getAttribute('data-tip-age');
      }
      if (idx !== current) { resSize.classList.remove('is-pop'); void resSize.offsetWidth; resSize.classList.add('is-pop'); }
      current = idx;
      rows.forEach(function (r, i) { r.classList.toggle('is-on', i === idx); });
      resSize.firstChild.nodeValue = data[idx].label;
      resTxt.innerHTML = '<b>' + data[idx].months + '</b>' + (tip ? '<br><span class="lv-finder__tip">' + tip + '</span>' : '');
      setBuy();
    }
    $$('[data-mode]', f).forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); }); });
    range.addEventListener('input', calc);
    if (pick) pick.addEventListener('click', function (e) {
      var pdp = $('[data-lv-pdp]');
      if (pdp) {
        e.preventDefault();
        pdp.dispatchEvent(new CustomEvent('lv:size', { detail: { index: current } }));
        closeLayer(f.closest('.lv-modal'));
        var g = $('[data-lv-size-group]', pdp); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    if (buy) buy.addEventListener('click', function () {
      var pdp = pdpHere;
      if (pdp) {
        // hand over to the buy box: animal + bundle first, then the size, then its own button (bundles continue there)
        var form = $('form[data-lv-product]', pdp);
        // read the finder first: syncing the buy box fires its change event, which would copy its values back here
        var wantOpts = fOpts(), wantQty = fQty(), wantSize = current;
        if (form) {
          wantOpts.forEach(function (val, i) { if (i !== fsi) { var r = setRadio(form, 'input[data-opt="' + i + '"]', val); if (r) r.dispatchEvent(new Event('change', { bubbles: true })); } });
          var tr = setRadio(form, 'input[data-lv-tier]', wantQty); if (tr) tr.dispatchEvent(new Event('change', { bubbles: true }));
        }
        pdp.dispatchEvent(new CustomEvent('lv:size', { detail: { index: wantSize } }));
        closeLayer(f.closest('.lv-modal'));
        if (form) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); }
        return;
      }
      var vv = fVariant();
      if (!vv || !vv.a) return;
      if (fQty() > 1 && fd && fd.url) {
        // a bundle is built on the product page: open it with this animal, size and bundle already picked
        var u = new URL(fd.url, window.location.href);
        u.searchParams.set('style', fStyle()); u.searchParams.set('size', sizeVals[current]); u.searchParams.set('bundle', fQty());
        buy.classList.add('is-loading'); burst(buy);
        window.location.href = u.toString();
        return;
      }
      buy.classList.add('is-loading'); buyLabel.textContent = LV.strings.to_checkout || LV.strings.adding;
      burst(buy);
      cartPost((LV.routes.cart_add || '/cart/add') + '.js', { items: [{ id: vv.id, quantity: 1 }] })
        .then(function () { window.location.href = root + 'checkout'; })
        .catch(function () { buy.classList.remove('is-loading'); setBuy(); });
    });
    // Size chart rows are clickable: tapping a size moves the slider to the middle of that size
    rows.forEach(function (r, i) {
      r.tabIndex = 0;
      r.setAttribute('role', 'button');
      r.setAttribute('aria-label', 'Choose size ' + data[i].label);
      function choose() {
        var d = data[i], v;
        if (mode === 'age') v = Math.max(0, Math.round(((i ? data[i - 1].age : 0) + d.age) / 2 - 0.5));
        else if (mode === 'cm') v = Math.round((d.lo + d.hi) / 2);
        else v = Math.round((d.lo + d.hi) / 2 / 2.54 * 2) / 2;
        range.value = v;
        calc();
        if (buy) { buy.classList.remove('is-wave'); void buy.offsetWidth; buy.classList.add('is-wave'); setTimeout(function () { buy.classList.remove('is-wave'); }, 1500); }
        if (window.innerWidth < 860) (buy || resSize).scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      }
      r.addEventListener('click', choose);
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(); } });
    });
    setMode('in');
  });

  /* ---------- Anatomy hotspots ---------- */
  $$('[data-lv-anat]').forEach(function (a) {
    var spots = $$('.lv-spot', a), items = $$('.lv-anat__item', a);
    function on(i) {
      spots.forEach(function (s, k) { s.setAttribute('aria-expanded', k === i ? 'true' : 'false'); });
      items.forEach(function (it, k) { it.classList.toggle('is-on', k === i); if (k === i) { it.classList.add('is-play'); setTimeout(function () { it.classList.remove('is-play'); }, 1200); } });
    }
    spots.forEach(function (s, i) { s.addEventListener('click', function () { on(i); }); s.addEventListener('mouseenter', function () { on(i); }); });
    items.forEach(function (it, i) { it.addEventListener('mouseenter', function () { on(i); }); it.addEventListener('click', function () { on(i); }); });
    on(0);
  });

  /* ---------- Squirrel countdown to the real dispatch cut-off (US Eastern, weekends skipped) ---------- */
  $$('[data-lv-countdown]').forEach(function (el) {
    var H = +el.getAttribute('data-cutoff') || 14;
    var out = $('[data-lv-count-time]', el), days = $$('[data-lv-count-day]', el), bites = $$('.lv-cd__bites circle', el);
    function nyNow() { return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); }
    // "Ends at" set in the editor (YYYY-MM-DD HH:MM, US Eastern): count down to that moment, hide once it's over
    var em = (el.getAttribute('data-end') || '').match(/(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    var endAt = em ? new Date(+em[1], em[2] - 1, +em[3], +(em[4] || 23), +(em[5] || (em[4] ? 0 : 59))) : null;
    function tick() {
      var now = nyNow(), target = new Date(now), label = 'today\u2019s';
      if (endAt) {
        if (now >= endAt) { el.style.display = 'none'; return; }
        target = endAt;
      } else target.setHours(H, 0, 0, 0);
      var wd = now.getDay();
      if (!endAt && (wd === 0 || wd === 6 || now >= target)) {
        do { target.setDate(target.getDate() + 1); } while (target.getDay() === 0 || target.getDay() === 6);
        var diffDays = Math.round((new Date(target.getFullYear(), target.getMonth(), target.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 864e5);
        label = diffDays === 1 ? 'tomorrow\u2019s' : target.toLocaleDateString('en-US', { weekday: 'long' }) + '\u2019s';
      }
      var ms = target - now, s = Math.max(0, Math.floor(ms / 1000));
      var d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), sec = s % 60;
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      if (el.hasAttribute('data-boxes')) out.innerHTML = '<i>' + (d * 24 + h) + '<small>h</small></i><i>' + pad(m) + '<small>m</small></i><i>' + pad(sec) + '<small>s</small></i>';
      else out.textContent = (d ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      days.forEach(function (x) { x.textContent = x.hasAttribute('data-plain') ? label.replace('\u2019s', '') : label; });
      var p = 1 - Math.min(1, ms / (24 * 3600 * 1000));
      var n = Math.ceil(p * bites.length);
      bites.forEach(function (b, i) { b.classList.toggle('is-on', i < n); });
      el.classList.toggle('is-hurry', ms < 2 * 3600 * 1000);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- Spotlight stage: tilt toward the cursor, tap = happy wiggle + acorn burst ---------- */
  $$('[data-lv-stage]').forEach(function (st) {
    var hero = $('[data-lv-tilt]', st);
    if (finePointer && !reduce && hero) {
      st.addEventListener('pointermove', function (e) {
        var r = st.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        st.style.transform = 'perspective(900px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
      });
      st.addEventListener('pointerleave', function () { st.style.transform = ''; });
      st.style.transition = 'transform .5s cubic-bezier(.45,0,.2,1)';
    }
    st.addEventListener('click', function () {
      st.classList.remove('is-wiggle'); void st.offsetWidth; st.classList.add('is-wiggle');
      burst(hero || st, true);
    });
  });

  /* ---------- Baby on the button: pops up and waves now and then (only when visible, not hovered) ---------- */
  if (!reduce) {
    var babyBtns = $$('.lv-btn--baby');
    if (babyBtns.length) setInterval(function () {
      babyBtns.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight || b.matches(':hover') || !r.width) return;
        b.classList.remove('is-wave'); void b.offsetWidth; b.classList.add('is-wave');
        setTimeout(function () { b.classList.remove('is-wave'); }, 1500);
      });
    }, 6500);
  }

  /* ---------- Mobile shop bar on the home page: shows once the hero CTA is out of view, hides at the footer ---------- */
  $$('[data-lv-mbar]').forEach(function (bar) {
    var hero = bar.closest('.lv-hero'), foot = $('.lv-footer');
    function check() {
      var past = hero.getBoundingClientRect().bottom < 80;
      var nearFoot = foot && foot.getBoundingClientRect().top < window.innerHeight - 40;
      bar.classList.toggle('is-on', past && !nearFoot);
    }
    window.addEventListener('scroll', check, { passive: true }); check();
  });

  /* ---------- "#buy" CTAs: glide to the buy box and point at the sizes ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#buy"]');
    if (!a) return;
    var form = document.getElementById('buy') || $('form[data-lv-product]');
    if (!form) return;
    e.preventDefault();
    var group = $('[data-lv-size-group]', form) || form;
    group.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
    if (!$('[data-lv-size-group] input:checked', form)) {
      setTimeout(function () {
        $$('[data-lv-size-group] .lv-chip', form).forEach(function (c, i) {
          setTimeout(function () { c.classList.remove('is-hi'); void c.offsetWidth; c.classList.add('is-hi'); }, i * 70);
        });
      }, 600);
    }
  });

  /* ---------- Reel arrows ---------- */
  $$('[data-lv-reel]').forEach(function (w) {
    var r = $('.lv-reel', w);
    $$('[data-dir]', w).forEach(function (b) { b.addEventListener('click', function () { r.scrollBy({ left: +b.getAttribute('data-dir') * r.clientWidth * 0.7, behavior: 'smooth' }); }); });
  });

  /* ---------- Night snow (cold outside, warm inside) ---------- */
  $$('[data-lv-snow]').forEach(function (sec) {
    if (reduce) return;
    var c = document.createElement('canvas');
    sec.insertBefore(c, sec.firstChild);
    var ctx = c.getContext('2d'), flakes = [], w, h, dpr = Math.min(2, window.devicePixelRatio || 1), running = false;
    function size() { w = sec.clientWidth; h = sec.clientHeight; c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size(); window.addEventListener('resize', size);
    var leaves = sec.getAttribute('data-lv-snow') === 'leaves';
    var cols = ['#E2A866', '#B8743A', '#D98C4A', '#F2A6B3'];
    for (var i = 0; i < (leaves ? 28 : 70); i++) flakes.push({ x: Math.random() * w, y: Math.random() * h, r: leaves ? 7 + Math.random() * 7 : 1 + Math.random() * 2.6, s: leaves ? 0.5 + Math.random() * 0.9 : 0.3 + Math.random() * 0.8, p: Math.random() * 6, k: Math.random() < 0.25 ? 'acorn' : 'leaf', c: cols[i % 4], a: Math.random() * 6 });
    function drawLeaf(f) {
      ctx.save(); ctx.translate(f.x, f.y); ctx.rotate(f.a);
      if (f.k === 'acorn') {
        ctx.fillStyle = '#E2A866'; ctx.beginPath(); ctx.ellipse(0, f.r * 0.25, f.r * 0.55, f.r * 0.7, 0, 0, 6.283); ctx.fill();
        ctx.fillStyle = '#6B4532'; ctx.beginPath(); ctx.ellipse(0, -f.r * 0.2, f.r * 0.72, f.r * 0.42, 0, 3.14, 6.283); ctx.fill();
        ctx.fillRect(-1, -f.r * 0.85, 2, f.r * 0.4);
      } else {
        ctx.fillStyle = f.c; ctx.globalAlpha = 0.85; ctx.beginPath(); ctx.ellipse(0, 0, f.r, f.r * 0.45, 0, 0, 6.283); ctx.fill();
        ctx.globalAlpha = 0.5; ctx.strokeStyle = '#4A2C1D'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(-f.r, 0); ctx.lineTo(f.r, 0); ctx.stroke();
      }
      ctx.restore();
    }
    function tick(t) {
      if (!running) return;
      ctx.clearRect(0, 0, w, h);
      ctx.fillStyle = 'rgba(255,247,236,.75)';
      flakes.forEach(function (f) {
        f.y += f.s; f.x += Math.sin(t / 1800 + f.p) * (leaves ? 0.8 : 0.35);
        if (f.y > h + 20) { f.y = -20; f.x = Math.random() * w; }
        if (leaves) { f.a += 0.012 * Math.sin(t / 900 + f.p); drawLeaf(f); }
        else { ctx.beginPath(); ctx.arc(f.x, f.y, f.r, 0, 6.283); ctx.fill(); }
      });
      requestAnimationFrame(tick);
    }
    new IntersectionObserver(function (en) { running = en[0].isIntersecting; if (running) requestAnimationFrame(tick); }).observe(sec);
  });

  /* ---------- Footer newsletter success scroll ---------- */
  if (/customer_posted=true/.test(location.search) || /#lv-news/.test(location.hash)) {
    var n = $('#lv-news'); if (n) n.scrollIntoView({ block: 'center' });
  }
})();

/* Review cards carousel: arrows move one card, loop at the ends */
document.querySelectorAll('[data-lv-rcards]').forEach(function (box) {
  var track = box.querySelector('[data-lv-rcards-track]');
  function step(d) {
    var w = track.clientWidth + 12, max = track.scrollWidth - track.clientWidth - 2;
    var to = track.scrollLeft + d * w;
    if (to > max + w / 2) to = 0; else if (to < -w / 2) to = track.scrollWidth;
    track.scrollTo({ left: to, behavior: 'smooth' });
  }
  box.querySelector('[data-lv-rcards-prev]').addEventListener('click', function () { step(-1); });
  box.querySelector('[data-lv-rcards-next]').addEventListener('click', function () { step(1); });
});
